import { render } from "./PageCallAction.vue?vue&type=template&id=738dd6ee"
import script from "./PageCallAction.vue?vue&type=script&lang=js"
export * from "./PageCallAction.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__